export abstract class IdCodeLibelle {
    public id: number = undefined;
    public code: string = undefined;
    public libelle: string = undefined;
}
